<!-- <!doctype html>
<html lang="en">
<head>
  <meta charset="utf-8">
  <title>ระบบค้นหาและแนะนำรหัสประเภทธุรกิจ - กรมพัฒนาธุรกิจการค้า</title>
  <base href="/index">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link rel="icon" type="image/x-icon" href="favicon.ico">
</head>
<body>


</body>
</html> -->


<router-outlet></router-outlet>
